import { create } from 'zustand'

interface UIState {
  sidePanelOpen: boolean
  activeTab: string
  toggleSidePanel: () => void
  setActiveTab: (tab: string) => void
}

export const useUIStore = create<UIState>((set) => ({
  sidePanelOpen: true,
  activeTab: 'floors',
  toggleSidePanel: () => set((s) => ({ sidePanelOpen: !s.sidePanelOpen })),
  setActiveTab: (tab) => set({ activeTab: tab }),
}))
